import React, { useId } from 'react';

// Friendly wordmark: a rounded teal tile with a fresh water droplet and a
// couple of little bubbles, next to the name. Used in the navbar and footer.
const Logo = ({ height = 40, light = false }) => {
  const ink = light ? '#ffffff' : '#25332c';
  const mark = Math.round(height);
  const gid = useId(); // unique gradient id so navbar + footer instances don't collide

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.6rem' }}>
      <svg width={mark} height={mark} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1FB398" />
            <stop offset="1" stopColor="#0E8C76" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="44" height="44" rx="15" fill={`url(#${gid})`} />
        {/* water droplet */}
        <path d="M23 12.5c5.2 6 8.4 9.7 8.4 14.2a8.4 8.4 0 1 1-16.8 0c0-4.5 3.2-8.2 8.4-14.2z" fill="#ffffff" />
        {/* soft shine on the droplet */}
        <path d="M20 27.2a4 4 0 0 0 3.2 4.9" stroke="#bfe9df" strokeWidth="1.6" strokeLinecap="round" />
        {/* bubbles */}
        <circle cx="32.5" cy="15" r="3.1" fill="#F3A23B" />
        <circle cx="15.5" cy="16.5" r="1.7" fill="#ffffff" opacity="0.9" />
      </svg>
      <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: Math.round(height * 0.44), lineHeight: 1, color: ink, letterSpacing: '-0.01em' }}>
        Veni Vidi <span style={{ color: '#16a085' }}>Laundry</span>
      </span>
    </span>
  );
};

export default Logo;
